<template>
    <div v-if="this.$md.mobile() !== null">
        <i class="mobile-columns-customization" @click="togglePresetsMenu"></i>
        <div class="customization-columns-menu-wrapper-mobile" v-show="presetsMenuShown">
            <div class="header">
                <span @click="onCancel">
                    <i class="close"></i>
                </span>
                <span>Customize Column</span>
                <span @click="onApply">Save</span>
            </div>
            <div class="body">
                <span class="search-wrapper">
                    <input type="text" name="search" placeholder="Search" autocomplete="off" v-model="search">
                </span>
                <div class="columns-wrapper">
                    <draggable v-model="checkedColumns" :options="{handle: '.reorder-item'}">
                        <div v-for="column in filteredColumns" :key="column.id" class="column">
                            <span>{{column.title}}</span>
                            <span class="reorder-item"><i class="material-icons">reorder</i></span>
                            <span class="reorder-switcher">
                            <Switcher 
                                :value="column.id" 
                                :checked="isChecked(column.id)"
                                @toggle="toggleCheckedColumn(column.id)"
                            />   
                            </span>                         
                        </div>
                    </draggable>
                </div>
            </div>
        </div>
    </div>
    <div v-else>
        <div v-click-outside="closePresetsMenu">
        <span @click="togglePresetsMenu">
            Columns: {{presetName}}
            <i class="icon-dropdown"></i>
        </span>
            <div class="customization-columns-menu-wrapper" v-show="presetsMenuShown">
                <div class="presets-wrapper">
                    <div style="text-align: left; margin: 10px 10px 10px 0;" @click="usePreset()">
                        <i class="selected-preset" v-visible="constants.NAME_DEFAULT == presetName"></i>
                        <span style="padding-left: 5px;">{{constants.NAME_DEFAULT}}</span>
                    </div>
                    <div v-for="(existedPresetData, existedPresetName) in existedPresetsList" style="text-align: left;margin: 10px 10px 10px 0;">
                        <div v-if="existedPresetData != null" @click="usePreset(existedPresetName)">
                            <i v-visible="existedPresetName == presetName" class="selected-preset"></i>
                            <span style="padding-left: 5px; padding-right: 15px;">{{existedPresetName}}</span>
                            <span style="float:right;">
                              <i class="edit-preset" style="margin-right: 10px;" @click.stop="editPreset(existedPresetName)"></i>
                              <i class="remove-preset" @click.stop="removePreset(existedPresetName)"></i>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="preset-create-wrapper">
                    <span @click="toggleCustomizationMenu">Customize Columns...</span>
                </div>
                <div class="customization-menu-wrapper" v-if="customizationMenuShown">
                    <div class="menu-preset-header">Customize Columns</div>
                    <div>
                        <div class="existed-columns-list-wrapper">
                            <div class="existed-columns-list-search">
                                <input type="text" name="search" placeholder="Search" autocomplete="off" v-model="search">
                            </div>
                            <div class="existed-columns-list">
                                <div v-for="column in filteredColumns" class="control-group">
                                    <label class="control control-checkbox">
                                        <input 
                                            type="checkbox" 
                                            :value="column.id" 
                                            :checked="isChecked(column.id)"
                                            @click="toggleCheckedColumn(column.id)"/>
                                        {{column.title}}
                                        <div class="control_indicator"></div>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="selected-columns-list-wrapper">
                            <div class="selected-columns-count">
                                <span>
                                  <b>{{checkedColumns.length}}</b> Column selected
                                </span>
                                <span @click="selectAllColumns()" class="select_all">Select all</span>
                                <span @click="clearSelectedColumns()" class="clear">Clear all</span>
                            </div>
                            <div class="selected-columns-list">
                                <draggable v-model="checkedColumns" :options="{handle: '.reorder-item'}">
                                    <div v-for="(column, columnIndex) in checkedColumns" :key="column.id" class="selected-item">                                        
                                        <span class="reorder-item"><i class="reorder-item-icon"></i></span>
                                        <span class="element-label">{{ column.title }}</span>
                                        <span 
                                            class="remove-item" 
                                            @click.stop="removeCheckedColumns(column.id)"
                                        >
                                            <i class="remove-item-icon"></i>
                                        </span>
                                        <span 
                                            v-bind:class="['fix-column', {'fixed' : isFixed(column.id)}]"  
                                            v-if="column.fixable" 
                                            @click="toggleFixColumn(column.id)"
                                        >
                                            <i class="fix-item-icon"></i>
                                        </span>
                                    </div>
                                </draggable>
                            </div>
                        </div>
                        <div class="customize-columns-control-buttons-wrapper">
                            <div class="save-as-preset-wrapper">
                                <template v-if="needSavePreset">
                                    <div style="display: inline-block;">
                                        <label class="control control-checkbox no-hover">
                                            <input type="checkbox" v-model="needSavePreset">
                                            <div class="control_indicator" style="top: 0;"></div>
                                        </label>
                                    </div>
                                    <div style="display: inline-block;">
                                        <div style="font-size:14px;text-align:left;color: #4a90e2;">Save as preset</div>
                                        <input type="text" v-model="newPresetName" class="preset-input">
                                    </div>
                                    <div class="clear"></div>
                                </template>
                                <template v-else>
                                    <label class="control control-checkbox no-hover">
                                        <input type="checkbox" v-model="needSavePreset">Save as preset
                                        <div class="control_indicator"></div>
                                    </label>
                                </template>
                            </div>
                            <div class="action-button-wrapper">
                                <button class="cancel-action" @click="onCancel">Cancel</button>
                                <button class="apply-action" @click="onApply">Apply</button>
                            </div>
                            <div class="clear"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import Vue from 'vue';
    import Switcher from "@/components/common/switcher/v1/Switcher"
    import draggable from 'vuedraggable';
    import VueLocalStorage from 'vue-ls';
    import _ from 'lodash';
    import constants from "./constants";

    Vue.use(VueLocalStorage, {
        namespace: 'presets__'
    });

    export default {
        name: "customization-columns",
        components: {
            Switcher,
            draggable
        },
        props: {
            namespace: {
                type: String,
                required: true
            },

            columns: {
                type: Array,
                required: true
            },

            defaultSelectedColumns: {
                type: Array,
                required: true,
            },

            selectedColumns: {
                type: Array,
                required: false,
                default: () => []
            }, 
            
            fixedColumns: {
                type: Array,
                required: false,
                default: () => []
            },
        },
        data (){

            let existedPresetsList = {};
            let list = this.$ls.get(this.namespace + '_presetsList') || {};
            _.each(list, (preset, name) => existedPresetsList[name] = preset);

            return {
                constants: constants,
                newPresetName: '',
                presetName: constants.NAME_DEFAULT,
                presetsMenuShown: false,
                customizationMenuShown: false,
                search: '',
                checkedColumnsIds: [],
                fixedColumnsIds: [],
                needSavePreset: false,                
                existedPresetsList: existedPresetsList
            }
        },

        mounted() {
            this.$set(this, 'checkedColumnsIds', _.cloneDeep(this.selectedColumns));
            this.$set(this, 'fixedColumnsIds',   _.cloneDeep(this.fixedColumns));
            this.presetName = this.getPresetName(this.selectedColumns, this.fixedColumns);
        },

        computed: {
            checkedColumns: {
                get() {         
                    let self = this;    

                    //Get only selected columns
                    let columns = _.filter(this.columns, (column) => {
                        return self.checkedColumnsIds.indexOf(column.id) != -1;
                    });
                    
                    //Sort in selected order
                    columns.sort((a,b) => {
                        return self.checkedColumnsIds.indexOf(a.id) - self.checkedColumnsIds.indexOf(b.id);
                    });

                    //Fixed columns in the top of list
                    columns.sort((a,b) => {
                        a = self.fixedColumnsIds.indexOf(a.id);
                        b = self.fixedColumnsIds.indexOf(b.id);
                        if( a === b  ) return 0;
                        if( a === -1 ) return 1;
                        if( b === -1 ) return -1;
                        return a-b;
                    });

                    return columns;
                },

                set(columns) {
                    let order = [];
                    columns.map(column => order.push(column.id));
                    this.$set(this, 'checkedColumnsIds', order);
                }
            },

            filteredColumns: function() {
                let columns = [];
                let regexp = new RegExp(this.search, 'i');
                return _.filter(this.columns, (column) => regexp.test(column.title));
            },
        },

        watch: {

            needSavePreset: function(savePreset) {
                if( savePreset ) {
                    this.newPresetName = (this.presetName !== this.constants.NAME_DEFAULT) ? this.presetName : '';
                }
            },

            existedPresetsList: function(existedPresetsList) {
                this.$ls.set(this.namespace + '_presetsList', existedPresetsList);
            },

            fixedColumns: function(fixedColumns) {
                this.$set(this, 'fixedColumnsIds', _.cloneDeep(fixedColumns));
                this.presetName = this.getPresetName(this.selectedColumns, this.fixedColumns);
            },

            selectedColumns: function(selectedColumns) {
                this.$set(this, 'checkedColumnsIds', _.cloneDeep(selectedColumns));
                this.presetName = this.getPresetName(this.selectedColumns, this.fixedColumns);
            },
        },

        methods: {
            closePresetsMenu() {
                this.presetsMenuShown = false;
                this.closeCustomizationMenu();
            },

            togglePresetsMenu() {
                if( this.presetsMenuShown ) {
                    this.closePresetsMenu()
                } else {
                    this.openPresetsMenu();
                }
            },

            openPresetsMenu() {
                this.presetsMenuShown = true;
            },

            toggleCustomizationMenu() {
                this.customizationMenuShown = !this.customizationMenuShown;
            },

            openCustomizationMenu() {
                this.customizationMenuShown = true;
            },

            closeCustomizationMenu() {
                this.customizationMenuShown = false;
            },

            selectAllColumns() {
                let order = [];
                this.columns.map(column => order.push(column.id));
                this.$set(this, 'checkedColumnsIds', order);
            },

            clearSelectedColumns() {
                this.checkedColumnsIds = [];
                this.fixedColumnsIds = [];
            },

            toggleFixColumn(columnId){
                let index = this.fixedColumnsIds.indexOf(columnId);
                if( index === -1 ) {
                    this.fixedColumnsIds.push(columnId);
                } else {
                    this.fixedColumnsIds.splice(index, 1);
                }
            },

            unFixColumn(columnId){
                if( this.isFixed(columnId) ) this.toggleFixColumn(columnId);
            },

            isFixed(columnId){
                return this.fixedColumnsIds.indexOf(columnId) !== -1;
            },

            toggleCheckedColumn(columnId){          
                let checkedColumnsIds = _.cloneDeep(this.checkedColumnsIds);
                let index = checkedColumnsIds.indexOf(columnId);
                if( index === -1 ) {

                    let columns   = _.map(this.columns, column => column.id !== columnId ? column.id : -1);
                    let nullIndex = columns.indexOf(-1);
                    let previous  = columns.splice(0, nullIndex);
                    previous      = _.reverse(previous);      
                    
                    let inserted  = false;
                    _.some(previous, previousColumnId => {
                        let index = checkedColumnsIds.indexOf(previousColumnId);                        
                        if( index !== -1 ) {
                            checkedColumnsIds.splice(index+1, 0, columnId);
                            inserted = true;
                            return true;
                        }
                        return false;
                    })

                    if( ! inserted ) {
                        checkedColumnsIds.unshift(columnId)
                    }
                    
                } else {
                    checkedColumnsIds.splice(index, 1);
                }

                this.$set(this, 'checkedColumnsIds', checkedColumnsIds);
            },

            isChecked(columnId) {
                return this.checkedColumnsIds.indexOf(columnId) !== -1;
            },

            removeCheckedColumns(columnId) {      
                if( this.isChecked(columnId) ) {
                    this.toggleCheckedColumn(columnId)
                }
                this.unFixColumn(columnId);
            },

            onCancel() {
                this.closeCustomizationMenu();
                this.closePresetsMenu();
                this.needSavePreset = false;
            },

            onApply() {

                let result = {
                    selectedColumns: _.cloneDeep(this.checkedColumnsIds),
                    fixedColumns: _.cloneDeep(this.fixedColumnsIds),
                };

                if( this.needSavePreset ) {
                    if( this.newPresetName.length === 0 ) {
                        alert('Plase enter preset name');
                        return false;
                    }
                } else {
                    this.newPresetName = this.constants.NAME_CUSTOM;
                }

                this.savePreset(this.newPresetName, result);
                this.needSavePreset = false;
                            
                this.closeCustomizationMenu();
                this.closePresetsMenu();
                this.usePreset(this.newPresetName);
                this.newPresetName = '';
            },

            savePreset(name, preset) {
                let newPreset = _.cloneDeep(preset);
                let existedPresetsList = _.cloneDeep(this.existedPresetsList);
                existedPresetsList[name] = newPreset;
                this.$set(this, 'existedPresetsList', existedPresetsList);
            },

            usePreset(name = '') {

                this.needSavePreset = false;
                let preset = _.get(this.existedPresetsList, name , {
                    selectedColumns: this.defaultSelectedColumns,
                    fixedColumns:[],
                });

                this.$set(this, 'checkedColumnsIds', preset.selectedColumns);
                this.$set(this, 'fixedColumnsIds', preset.fixedColumns);
                this.presetName = name.toString().length > 0 ? name : this.constants.NAME_DEFAULT;

                this.$emit('apply', preset);
            },

            editPreset(name = '') {                
                this.usePreset(name);                
                this.toggleCustomizationMenu();
                this.needSavePreset = true;
            },

            removePreset(name = '') {                
                if( name === this.presetName ) {
                    this.usePreset();
                }
                let existedPresetsList = _.cloneDeep(this.existedPresetsList);
                _.unset(existedPresetsList, name);
                this.$set(this, 'existedPresetsList', existedPresetsList);
            },

            getPresetName(selectedColumns, fixedColumns) {
                            
                let presetNames = [];
                let result = _.some(this.existedPresetsList, (preset, name) => {
                    let selectedSame = _.isEqual(preset.selectedColumns, selectedColumns);
                    let fixedSame    = _.isEqual(preset.fixedColumns,    fixedColumns);
                    if( selectedSame && fixedSame ) {
                        presetNames.push(name);
                    }
                });

                if( result === false ) {
                    if( _.isEmpty(fixedColumns) && _.isEqual(this.defaultSelectedColumns, selectedColumns) ) {
                        presetNames.push(this.constants.NAME_DEFAULT);
                    }
                }

                if( result === false && presetNames.length === 0 ) {
                    this.savePreset(this.constants.NAME_CUSTOM, {
                        selectedColumns: selectedColumns,
                        fixedColumns: fixedColumns
                    });

                    presetNames.push(this.constants.NAME_CUSTOM);
                }

                if( presetNames.indexOf(this.presetName) === -1 ) {
                    return presetNames.shift();
                }

                return this.presetName;
            }
        }
    }
</script>

<style lang="scss" scoped>

    .icon-dropdown {
        display: inline-block;
        width: 0.65em;
        height: 0.65em;
        margin-right: 5px;
        margin-left: 5px;
        background-image: url('/static/img/icon-dropdown-table.svg');
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        cursor: pointer;
    }

    .selected-preset {
        background-image: url('/static/img/icon-selected.svg');
        background-repeat: no-repeat;
        background-position: left center;
        background-size: contain;
        width: 12px;
        height: 12px;
        display: inline-block;
    }

    .edit-preset {
        background-image: url('/static/img/icon-edit.svg');
        background-repeat: no-repeat;
        background-position: left center;
        background-size: contain;
        width: 12px;
        height: 12px;
        display: inline-block;
    }

    .remove-preset {
        background-image: url('/static/img/icon-delete.svg');
        background-repeat: no-repeat;
        background-position: left center;
        background-size: contain;
        width: 12px;
        height: 12px;
        display: inline-block;
    }

    .customization-columns-menu-wrapper {
        position: absolute;
        background: #fff;
        z-index: 5;
        border: 1px solid #cecece;
        right: 0;
        margin-top: 10px;
        margin-right: 41px;
        min-width: 10vw;
        box-shadow: 1px 3px 7px 1px #cbcccd;

        & .presets-wrapper {
            padding: 5px 15px 5px 15px;
            border-bottom: 1px solid $border-color;

            & > div {
                cursor: pointer;
            }
        }

        & .preset-create-wrapper {
            padding: 15px;
            text-align: left;
        }
    }

    .customization-menu-wrapper {
        position: absolute;
        background: #fff;
        z-index: 5;
        border: 1px solid #cecece;
        top:0;
        right: 0;
        min-width: 30vw;
        margin-top: -1px;
        margin-right: -1px;
        box-shadow: 1px 3px 7px 1px #cbcccd;

        & > .menu-preset-header {
            text-align: left;
            padding: 10px 0 5px 10px;
            border-bottom: 1px solid #cecece;
        }
    }

    .existed-columns-list-wrapper {
        float: left;
        width: 40%;
        text-align: left;
        padding: 10px;
        border-right: 1px solid #cecece;

        & > input[type='text'] {
            width: 100%;
        }

        & > .existed-columns-list {
            max-height: 300px;
            overflow-y: scroll;

            &::-webkit-scrollbar-track
            {
                border-radius: 8px;
                background-color: #F5F5F5;
            }

            &::-webkit-scrollbar
            {
                width: 8px;
                height: 8px;
                background-color: #F5F5F5;
            }

            &::-webkit-scrollbar-thumb
            {
                border-radius: 4px;
                -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
                background-color: #868686;
                height: 55%;
            }
        }
    }

    .selected-columns-list-wrapper {
        float: left;
        width: 60%;

        & > .selected-columns-count {
            display: flex;
            justify-content: space-between;
            text-align: left;
            font-size: 14px;
            color: #797979;
            padding: 10px;
            border-bottom: 1px solid #cecece;
            flex-wrap: wrap;

            & > span.clear, & > span.select_all {
                color: #4a90e2;
                cursor: pointer;
            }
        }

        & > .selected-columns-list {

            max-height: 300px;
            overflow-y: auto;

            & .selected-item {

                .fix-column {

                    float: right;
                    margin-right: 15px;
                    display: none;

                
                    .fix-item-icon {  
                        display: inline-block;                      
                        width: 0.85em;
                        height: 0.85em;
                        background-image: url('/static/img/icon-pin.svg');
                        background-repeat: no-repeat;
                        background-position: left center;
                        background-size: contain;
                    }

                    &.fixed {
                        display: inline-block;   

                        .fix-item-icon {  
                            background-image: url('/static/img/icon-pin-fixed.svg');
                        }
                    }
                }

                & > .remove-item {

                    cursor: pointer;

                    & > .remove-item-icon {
                        display: inline-block;
                        width: 0.85em;
                        height: 0.85em;
                        background-image: url('/static/img/icon-customize-columns-close.svg');
                        background-repeat: no-repeat;
                        background-position: left center;
                        background-size: contain;
                    }
                }

                & > .reorder-item  {
                    & > .reorder-item-icon {
                        display: inline-block;
                        width: 0.85em;
                        height: 0.85em;
                        background-image: url('/static/img/icon-customize-columns-reorder.svg');
                        background-repeat: no-repeat;
                        background-position: left center;
                        background-size: contain;
                    }
                }

                &:hover {
                    .fix-column {
                        display: inline-block;
                    }
                }
            }

            &::-webkit-scrollbar-track
            {
                border-radius: 8px;
                background-color: #F5F5F5;
            }

            &::-webkit-scrollbar
            {
                width: 8px;
                height: 8px;
                background-color: #F5F5F5;
            }

            &::-webkit-scrollbar-thumb
            {
                border-radius: 4px;
                -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
                background-color: #868686;
                height: 55%;
            }

            & > div > .selected-item {
                border: 1px solid #cecece;
                text-align: left;
                padding: 5px;
                margin: 5px;

                & > .reorder-item {
                    float: left;
                    cursor: pointer;

                    & > i {
                        font-size: 1.1em;
                    }

                }

                & > .remove-item {
                    float: right;

                    & > i {
                        font-size: 1.1em;
                    }

                }

                & > .element-label {
                    margin-left: 15px;
                }

            }
        }
    }

    .existed-columns-list-search {
        margin-bottom: 10px;

        & > input {
            width: 100%;
            border: 1px solid $border-color;
            border-radius: 3px;
            text-indent: 6px;
            background-image: url('/static/img/icon-search.svg');
            background-repeat: no-repeat;
            padding: 5px 15px 5px 22px;
            background-position: 4px;
            background-size: 1.5em 1em;
            font-size: 12px;
        }
    }

    .customize-columns-control-buttons-wrapper {
        clear: both;
        padding: 10px;
        border-top: 1px solid #cecece;

        & > .save-as-preset-wrapper {
            float: left;
            color: #797979;

            & > input[type="checkbox"] {
                visibility: hidden;
            }

            & .checkbox_indicator {
                position: absolute;
                top: 5px;
                left: 5px;
                height: 15px;
                width: 15px;
                background: #FFFFFF;
                border: 1px solid #979797;
                border-radius: 3px;
            }

            & .preset-input {
                border: 0;
                outline: none;
                border-bottom: 1px solid #4a90e2;
            }

        }

        & > .action-button-wrapper {
            float: right;

            & > .cancel-action {
                margin-right: 15px;
                background-color: #fff;
                border: 1px solid #dddddd;
                border-radius: 3px;
                color: #666666;
            }

            & > .apply-action {
                background-color: #4a90e2;
                border: 1px solid #3474c0;
                border-radius: 3px;
                color: #fff;
            }
        }

    }

    .control.control-checkbox {
        .control_indicator {
            border-radius: 3px;
        }

        &.no-hover {
            background: none;
        }
    }

    @media (max-width : 1280px) {
        .customization-menu-wrapper {
            min-width: 50vw;
        }
    }

    @include mobile-only {
        .mobile-columns-customization {
            display: inline-block;
            width: 2em;
            height: 2em;
            background-image: url('/static/img/icon-mobile-columns-customization.svg');
            background-repeat: no-repeat;
            background-position: left center;
            background-size: contain;
        }

        .customization-columns-menu-wrapper-mobile {
            position: fixed;
            background: #fff;
            z-index: 5;
            border: 1px solid #cecece;
            top: 0;
            left: 0;
            width: 100%;
            font-size: 1rem;
            cursor: default;

            & > .header {

                display: flex;
                justify-content: space-between;
                background: #4a90e2;
                height: 52px;
                align-items: center;
                position: sticky;
                z-index: 999;

                & > span {
                    color: #fff;

                    & > i.close {
                        display: inline-block;
                        width: 1.15em;
                        height: 1.15em;
                        background-image: url('/static/img/icon-close.svg');
                        background-repeat: no-repeat;
                        background-position: left center;
                        background-size: contain;
                    }
                }

                & > span:first-child {
                    margin-left: 15px;
                }

                & > span:last-child {
                    margin-right: 15px;
                }

            }

        }

        .body > .search-wrapper {

            margin-top: 10px;
            width: calc(100% - 20px);
            margin-left: 10px;
            margin-right: 10px;

            & > input {
                width: 100%;
                height: 40px;
                text-indent: 25px;
                border: 1px solid $border-color;
                border-radius: 3px;
                background-image: url('/static/img/icon-search.svg');
                background-repeat: no-repeat;
                background-position: 10px 12px;
                background-size: contain;
                background-size: 1em;
                padding-left: 10px;
                font-size: 0.85rem;
            }

        }

        .columns-wrapper {
            .column {
                grid-template-columns: 1fr 1fr auto;
                border-bottom: 1px solid #cecece;
                padding-bottom: 10px;
                vertical-align: middle;
                padding-top: 10px;
                padding-left: 15px;
                padding-right: 15px; 

                span:first-child {
                    float:left;
                }

                .reorder-item,
                .reorder-switcher{
                    float:right
                }  

                &:after {
                    content: "";
                    clear: both;
                    display: block;
                }             
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/common/customizationColumns/v1/CustomizationColumns.vue